<template>
  <div class="dialog-wrap">
    <el-dialog title="调剂信息新建"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="907px">
      <el-form :model="form"
               label-width="100px"
               ref="formRules"
               :rules="rules">
        <el-form-item label="年份"
                      prop="year">
          <el-select v-model="form.year"
                     placeholder="请选择">
            <el-option label="2027"
                       value="2027"></el-option>
            <el-option label="2026"
                       value="2026"></el-option>
            <el-option label="2025"
                       value="2025"></el-option>
            <el-option label="2024"
                       value="2024"></el-option>
            <el-option label="2023"
                       value="2023"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校"
                      prop="college_name">
          <el-select v-model="form.college_code"
                     filterable
                     placeholder="请选择"
                     @change="collegeChange"
                     clearable>
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业">
          <el-select v-model="form.major_code"
                     placeholder="请选择"
                     filterable
                     clearable
                     @change="majorChange"
                     @clear="majorClear">
            <el-option v-for="(item, index) in majorList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学院">
          <el-select v-model="form.academy_code"
                     placeholder="请选择"
                     @change="academyChange();$forceUpdate()"
                     @clear="academyClear"
                     filterable
                     clearable>
            <el-option v-for="(item, index) in academyList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
              <span>{{ `${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题"
                      prop="article_title">
          <el-input v-model="form.article_title"
                    placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="内容"
                      prop="">
          <VueEditor :content="form.article_content"
                     placeholder="这个是文章内容编辑区域，如果是转载内容，请著名转载，标注好侵权及删的声明。"
                     @change="handleContentChange" />
        </el-form-item>
        <el-form-item label="原文地址"
                      prop="article_url">
          <el-input v-model="form.article_url"
                    placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueEditor from '@/components/VueEditor'
import { collegeMajorList, majorSubjectList, academyList } from '@/api/common'
export default {
  components: {
    VueEditor,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {},
      rules: {
        year: [{ required: true, message: '请选择年份', trigger: 'blur' }],
        college_name: [
          { required: true, message: '请选择院校', trigger: 'blur' },
        ],
        article_title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        article_url: [
          { required: true, message: '请输入原文地址', trigger: 'blur' },
        ],
      },
      majorList: [],
      academyList: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  created() {
    this.$store.dispatch('getAllColleges')
  },
  methods: {
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.form.college_name = this.$store.state.collegeList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
      this.getMajor(e)
      this.getAcademy(e)
    },
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || []
      })
    },

    // 录取专业选择后还要搜索相对应的专业名称
    majorChange(e) {
      this.form.academy_name = ''
      this.form.academy_code = ''
      if (e) {
        this.form.major_name = this.majorList.find((item) => {
          return item.code === e //筛选出匹配数据
        }).name
      }
      this.getAcademy(this.form.college_code, e)
    },
    majorClear() {
      this.major_name = ''
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
      })
    },
    // 录取院校选择后还要搜索相对应的院校名称
    academyChange(e) {
      if (e) {
        this.form.academy_name = this.academyList.find((item) => {
          return item.code === e //筛选出匹配数据
        }).name
      }
    },
    academyClear() {
      this.form.major_name = ''
      this.form.major_code = ''
      this.getAcademy(this.form.college_code)
    },
    handleClose() {
      this.$emit('close')
    },
    handleContentChange(editor) {
      this.form.article_content = editor.html
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          this.$emit('submit', { obj: this.form })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.el-select {
  width: 430px;
}
</style>
